export const GET_SETTING_ACTIVITIES_REQUEST = "GET_SETTING_ACTIVITIES_REQUEST";
export const GET_SETTING_ACTIVITIES_RESPONSE = "GET_SETTING_ACTIVITIES_RESPONSE";
export const GET_SETTING_ACTIVITIES_ERROR = "GET_SETTING_ACTIVITIES_ERROR";
